import { LinearProgress } from '../primitives/linear-progress.js'
import type { FC, HTMLAttributes, ReactNode } from 'react'

interface ProgressOnLoadProps extends HTMLAttributes<HTMLDivElement> {
  loading?: boolean
  title?: string
  Component?: FC
  children: ReactNode
}

/** Show a progress bar on load. @default Component is LinearProgress */
export const ProgressOnLoad: FC<ProgressOnLoadProps> = ({ loading = false, title, Component = LinearProgress, children, className, style, ...rest }) => loading ? (
    <div className={className} style={style} {...rest}>
      <Component />
      {title ? (
        <span style={{ display: 'block', textAlign: 'center', fontSize: 'var(--tuna-typography-caption-fontSize)' }}>
          {title}
        </span>
      ) : null}
    </div>
  ) : (
    <div className={className} style={style} {...rest}>{children}</div>
  )

export default ProgressOnLoad
